<template>
  <div>
    <v-row dense align="center">
      <v-col cols="auto" class="mr-auto">
        <v-switch
          label="Use Data View"
          v-model="settings.useDataView"
          @change="(val) => onUpdate(val, `settings.useDataView`)"
        >
          Use Data View
        </v-switch>
      </v-col>
    </v-row>

    <div v-if="settings.useDataView">
      <v-select
        outlined
        dense
        v-model="settings.dataViewId"
        :items="dataViews.map(workspace => ({ label: workspace.name, value: workspace.id }))"
        @input="onDataViewSelect"
        item-text="label"
        label="Data View"
        clearable
        style="margin-bottom: 15px"
      ></v-select>
      <div v-if="settings.dataViewInputs">
      <div
        class="PVerifyAction__param-row mb-6"
        v-for="(param, i) in settings.dataViewInputs"
        :key="i"
      >
        <v-text-field
          class="PVerifyAction__param-row--field mr-2"
          outlined
          disabled
          dense
          label="Name"
          :value="param.name"
          @input="(val) => onUpdate(val, `settings.dataViewInputs[${i}].name`)"
        />
        <v-combobox
          class="PVerifyAction__param-row--field mr-2"
          outlined
          dense
          :value="param.value"
          @input="
          (val) => onUpdate(val?.name || val, `settings.dataViewInputs[${i}].value`)
        "
          :items="availableInputFields"
          item-text="name"
          item-value="name"
          label="Value"
          clearable
        ></v-combobox>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getModel, shTypes } from '@/util/actionsModels';
import { isObject } from 'lodash';
const { mapGetters: workspacesGetters } =
  createNamespacedHelpers('aiWorkspace');
const { mapGetters: workflowsGetters } =
  createNamespacedHelpers('workflows/details');

const {
  mapGetters: dataViewGetters,
  mapActions: dataViewActions,
} = createNamespacedHelpers('DataView');

export default {
  name: 'PVerifyGetBenefits',
  props: {},
  data() {
    return {
      driveFolders: [],
      loading: false,
    };
  },
  computed: {
    ...dataViewGetters({
      dataViews: 'DATA_VIEWS'
    }),
    ...workspacesGetters({
      selectedAction: 'SELECTED_ACTION',
      generalActions: 'WORKSPACE_GENERAL_ACTIONS',
    }),
    ...workflowsGetters({
      actionsOutputs: 'ACTION_OUTPUTS',
    }),
    settings() {
      return this.selectedAction.settings;
    },
    action() {
      return this.selectedAction.action_type;
    },
    availableInputFields() {
      let result = [];

      const inputModel = this.getOutputModels();
      if (inputModel) {
        if (Array.isArray(inputModel)) {
          const items = inputModel
            .filter((item) => item.type === shTypes.ARRAY)
            .map((i) => ({ name: i.name, uid: i.uid, field: i }));
          result.push(...items);
        } else if (
          typeof inputModel === 'object' &&
          inputModel.type === shTypes.ARRAY
        ) {
          const items = [
            {
              name: inputModel.name,
              uid: inputModel.uid,
              field: inputModel,
            },
          ];
          result.push(...items);
        }
        const flattenObjFields = (items, prefix) => {
          if (isObject(items)) {
            items.forEach((prop) => {
              const propWithPrefix = {
                name: !prefix ? prop.name : `${prefix}.${prop.name}`,
                uid: prop.uid,
                field: prop,
              };

              if (prop.type === shTypes.OBJECT) {
                result.push(propWithPrefix);
                flattenObjFields(prop.value, propWithPrefix.name);
              } else {
                result.push(propWithPrefix);
              }
            });
          }
        };

        if (inputModel.type === shTypes.OBJECT) {
          flattenObjFields(inputModel.value, inputModel.name);
        } else {
          const items = [
            {
              name: inputModel.name,
              uid: inputModel.uid,
              field: inputModel,
            },
          ];
          result.push(...items);
        }
      }

      return result;
    },
  },
  created() {
    this.getDataViews();
  },
  mounted() {
    this.getDataViews();
  },
  watch: {
    'selectedCustomer.customer_id'() {
      this.getDataViews();
    },
  },
  methods: {
    ...dataViewActions(['getDataViews']),
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    getOutputModels() {
      const pverifyModel = this.actionsOutputs['get_benefits_pverify'];
      const modelObj = {
        pid: '',
       request: {
         subscriber: {
           firstName: '',
           dob: '',
           lastName: '',
           memberID:'',
         },
         isSubscriberPatient: '',
         doS_StartDate:'',
         doS_EndDate:'',
         practiceTypeCode:'',
       },
        status: {
          is_valid: '',
          error: ''
        },
        response: {},
      };
      const model = getModel(modelObj, 'Benefits');
      const {
        DMESummary,
        PrimaryCareSummary,
        SpecialistOfficeSummary,
        SurgicalSummary,
        DiagnosticLabSummary,
        ChiropracticSummary,
        MRI_CT_ScanSummary,
        XRaySummary,
        SpecialistOfficeChemotherapy,
        ASC_FacilitySummary,
        PhysicalTherapySummary,
        TelemedicinePrimaryCareSummary,
        TelemedicineSpecialistSummary,
        TelemedicineUrgentCareSummary,
        TelemedicinePhysicalTherapySummary,
        TelemedicineMentalHealthSummary,
        OncologySummary,
      } = pverifyModel;

          model.value[2].value.push(DMESummary);
          model.value[2].value.push(PhysicalTherapySummary);
          model.value[2].value.push(PrimaryCareSummary);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(SurgicalSummary);
          model.value[2].value.push(DiagnosticLabSummary);
          model.value[2].value.push(ChiropracticSummary);
          model.value[2].value.push(MRI_CT_ScanSummary);
          model.value[2].value.push(XRaySummary);
          model.value[2].value.push(...SpecialistOfficeChemotherapy.value);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(OncologySummary);
          model.value[2].value.push(DMESummary);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(ASC_FacilitySummary);
          model.value[2].value.push(SpecialistOfficeSummary);
          model.value[2].value.push(PhysicalTherapySummary);
          model.value[2].value.push(TelemedicinePrimaryCareSummary);
          model.value[2].value.push(TelemedicineSpecialistSummary);
          model.value[2].value.push(TelemedicineUrgentCareSummary);
          model.value[2].value.push(TelemedicinePhysicalTherapySummary);
          model.value[2].value.push(TelemedicineMentalHealthSummary);
      return model;
    },
    onDataViewSelect(id) {
      this.settings.dataViewId = id;
      const schemaFields = Object.keys(this.dataViews.find((dataView) => dataView.id === this.settings.dataViewId)?.schema);
      this.settings.dataViewInputs = schemaFields.map((field) => {
        return {
          name: field,
          value: '',
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
